import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={20.93}
    height="6.8mm"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 16528 20296"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#231f20}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974319863040">
        <path
          d="M5215 19272h6099v1024H5215zM4231 14697c0 2224 1809 4034 4033 4034s4035-1810 4035-4034-1811-4033-4035-4033-4033 1810-4033 4033zM7501 8223h1527v1771H7501zM5488 0 0 7584h16528L11040 0z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
